import React from 'react';
import u from '../utilities/Utilities';
import EmptyPageLayout from '../components-app/EmptyPageLayout';
import {Footer,Step, LoadGraphic} from '../components-static/Common'
import store from 'store';
import '../styles/access-card.scss';
import QRCode from 'qrcode.react';
import Measure from 'react-measure';
import moment from 'moment';

export default class AccessCard extends React.Component{

    state={
        step:"view",
        instantiated:false,
        content:{
            visitor:{
                token:"none",
            },
        },
        loading:true,
        loadText:"Verifying Token...",
        dimensions:{width:0,height:0},
        print:false
    };

    componentDidMount=()=>{
        const token = store.get("access-card-token");
        if(token){
            this.getAppointmentDetails(token);
        }
        else{
            this.setState({step:"error",loading:false});
        }
        const action = u.getQuery(this.props,"action");
        this.setState({instantiated:true,print:(action=="print")});
    };

    getAppointmentDetails=(token)=>{
        u.post({
            url:"/noauth/get-access-card",
            data:{
                token:token
            },
            success:({valid,appointment,visitor})=>{
                if(valid){
                    appointment.visitor=visitor;
                    this.setState({content:appointment,loading:false});

                    if(this.state.print){
                        setTimeout(()=>{
                            window.print();
                        },500);
                    }
                }
                else{
                    this.setState({step:"error",loading:false,step:"error"});
                }
            },
            error:(error)=>{
                this.setState({error:error,loadText:error,step:"error"});
            },
        });
    };

    render=()=>{
        if(!this.state.instantiated){
            return <div/>
        }
        const content=this.state.content;
        const width = Math.floor(this.state.dimensions.width);
        const logoWidth = Math.round(width * 0.25);
        const singleDay = moment(content.start).isSame(content.end,"day");

        return (
            <EmptyPageLayout url="/access-card" title="Access Card">
                <div className="access-container">
                    <Step active={this.state.step=="view"}>
                        <div style={{position:"relative"}}>
                            <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                            <div className="access-card-container">
                                {
                                    (this.state.print)
                                        ?
                                        <img src="/images/app/soilbuild-go-logo-black.png" className="soilbuild-logo"/>
                                        :
                                        <img src="/images/app/soilbuild-go-logo.png" className="soilbuild-logo"/>
                                }

                                <Measure bounds onResize={contentRect => {this.setState({dimensions:contentRect.bounds})}}>
                                    {
                                        ({measureRef})=>
                                            (
                                                <div ref={measureRef} className="qr-code">
                                                    <QRCode value={content.visitor.token} size={width} renderAs="svg" level={(this.state.print) ? "L" : "Q"}
                                                        imageSettings={(this.state.print) ? undefined : {
                                                        src:(this.state.print) ? "/images/cards/soilbuild-qr-black.png" : "/images/cards/soilbuild-qr.png",
                                                        width:logoWidth,
                                                        height:logoWidth,
                                                    }}/>
                                                </div>
                                            )
                                    }
                                </Measure>

                                <div className="access-details">
                                    <div className="details-item bold">
                                        <div className="details-left">Guest:</div>
                                        <div className="details-right">{content.visitor.visitorName}</div>
                                    </div>

                                    <div className="details-item">
                                        <div className="details-left">Unit:</div>
                                        <div className="details-right">{content.tenantBlock}, {content.tenantUnit}</div>
                                    </div>

                                    <div className="details-item">
                                        <div className="details-left"><span className="mobile-hide">Valid </span>From:</div>
                                        <div className="details-right"><span className="mobile-hide no-print">From: </span>{moment(content.start).format("DD MMM YYYY (h:mma)")}</div>
                                    </div>

                                    <div className="details-item">
                                        <div className="details-left"><span className="mobile-hide">Valid </span>To:</div>
                                        <div className="details-right"><span className="mobile-hide no-print" style={{marginRight:"17px"}}>To: </span>{moment(content.end).format("DD MMM YYYY (h:mma)")}</div>
                                    </div>

                                    <div className="access-divider">
                                        <div className="access-invite no-print"><div className="access-invite-text">Invited By</div></div>
                                        <div className="access-divider-line"/>
                                    </div>

                                    <div className="details-item" style={{marginTop:"5px"}}>
                                        <div className="details-left">Invited By:</div>
                                        <div className="details-right">{content.staffName}</div>
                                    </div>

                                    <div className="details-item">
                                        <div className="details-left">Tenant:</div>
                                        <div className="details-right">{content.tenantName}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="no-print access-disclaimers">
                                <div className="disclaimer-text">Instructions</div>
                                <div style={{textAlign:"left",display:"inline-block",margin:"auto"}}>
                                    <ul>
                                        <li>Access pass only allows for entry during the validity period & is required to exit the property</li>
                                        <li>Access pass cannot be transferred or shared. Anti-passback protocols are established so you cannot enter again without exiting first</li>
                                        <li>Visit the reception counter if you are unable to enter the building due to Anti-Passback</li>
                                        <li className="no-print">If you do not have access to a smartphone or internet connection, a printed copy can be produced at the reception counter</li>
                                        <li>Upon entering, you agree to allow Building Management to use & distribute your information during an emergency</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="print-only access-disclaimers">
                                <div className="disclaimer-text">Instructions</div>
                                <div>
                                    <div className="disclaimer-li">Access pass only allows for entry during the validity period & is required to exit the property</div>
                                    <div className="disclaimer-li">Access pass cannot be transferred or shared. Anti-passback protocols are established so you cannot enter again without exiting first</div>
                                    <div className="disclaimer-li">Visit the reception counter if you are unable to enter the building due to Anti-Passback</div>
                                    <div className="disclaimer-li">Upon entering, you agree to allow Building Management to use & distribute your information during an emergency</div>
                                </div>
                            </div>
                        </div>
                    </Step>

                    <Step active={this.state.step == "error"}>
                        <div className="access-error">
                            <h1 className="text-negative" style={{marginTop:"0"}}>Invalid Access Pass</h1>
                            <div>
                                <div style={{margin:"20px auto"}}>Please ensure that you arrived at this page from the link provided in your email</div>
                                <div style={{margin:"20px auto"}}>If you are still seeing this message, your appointment may be been cancelled or your access revoked. Please proceed to the reception counter for assistance</div>
                            </div>
                        </div>
                    </Step>

                    <div className="no-print" style={{position:"relative"}}>
                        <Footer type="half"/>
                    </div>

                    <div className="print-only bottom-divider"/>
                </div>
            </EmptyPageLayout>
        )
    };
}
